import { ApiError, type MeResponse } from '@citibox-panel/api-client';

export interface FetchMeDeps {
  read: () => Promise<MeResponse>;
  refreshToken: () => Promise<unknown>;
}

// A 401 on /me is usually an ID token that expired between Firebase's refresh and the call: force
// one fresh token and read once more. A second 401 is a session that is really gone.
export function createFetchMe({ read, refreshToken }: FetchMeDeps): () => Promise<MeResponse> {
  return async () => {
    try {
      return await read();
    } catch (error) {
      if (!(error instanceof ApiError) || error.status !== 401) throw error;
      await refreshToken();
      return read();
    }
  };
}
